var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFmsModeling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "aq8xgpxsya"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15415",
    transform: "translate(1431 2738)",
    style: {
      fill: "#ff2e2e",
      opacity: 0.158
    },
    d: "M0 0h180v180H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 708",
    transform: "translate(-1431 -2738)",
    style: {
      clipPath: "url(#aq8xgpxsya)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59685",
    d: "M115.967 91.075H10.4a9.4 9.4 0 0 1-9.4-9.4V10.4A9.4 9.4 0 0 1 10.4 1h109.879a9.4 9.4 0 0 1 9.4 9.4v71.275a9.442 9.442 0 0 1-.183 1.854",
    transform: "translate(1455 2783.047)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 119",
    transform: "translate(1456 2802.447)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h128.679"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59686",
    d: "M76.342 6.357a2.174 2.174 0 1 1-2.174 2.174 2.173 2.173 0 0 1 2.174-2.174",
    transform: "translate(1477.238 2784.675)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59687",
    d: "M83.843 6.357a2.174 2.174 0 1 1-2.174 2.174 2.173 2.173 0 0 1 2.174-2.174",
    transform: "translate(1479.517 2784.675)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59688",
    d: "M91.343 6.357a2.174 2.174 0 1 1-2.174 2.174 2.173 2.173 0 0 1 2.174-2.174",
    transform: "translate(1481.797 2784.675)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59689",
    d: "M33.233 34.8v4.694a2.958 2.958 0 0 1-2.959 2.957H18.336a2.958 2.958 0 0 1-2.959-2.957v-11.94a2.959 2.959 0 0 1 2.959-2.959h11.938",
    transform: "translate(1459.37 2790.218)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59690",
    d: "M15.377 32.247v-4.694a2.957 2.957 0 0 1 2.959-2.953h11.938a2.957 2.957 0 0 1 2.957 2.957v11.94a2.958 2.958 0 0 1-2.957 2.959H18.336",
    transform: "translate(1459.37 2790.218)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59691",
    d: "M33.233 57.355v4.695a2.958 2.958 0 0 1-2.959 2.957H18.336a2.958 2.958 0 0 1-2.959-2.957V50.11a2.959 2.959 0 0 1 2.959-2.959h11.938",
    transform: "translate(1459.37 2797.073)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59692",
    d: "m19.685 53.486 3.551 3.551 10.173-7.555",
    transform: "translate(1460.679 2797.781)",
    style: {
      stroke: "#4cbbb8",
      strokeLinejoin: "round",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 120",
    transform: "translate(1521.233 2823.073)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h19.543"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 121",
    transform: "translate(1521.233 2853.437)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h24.879"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 122",
    transform: "translate(1561.528 2853.437)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h4.406"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 123",
    transform: "translate(1544.122 2838.256)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h21.811"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 124",
    transform: "translate(1557.122 2823.073)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h8.811"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59693",
    d: "M75.295 31.91a4.206 4.206 0 1 1-4.207-4.21 4.207 4.207 0 0 1 4.207 4.21z",
    transform: "translate(1475.024 2791.163)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 125",
    transform: "translate(1521.233 2838.256)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h7.869"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59694",
    d: "M65.475 43.553a4.206 4.206 0 1 1-4.206-4.206 4.207 4.207 0 0 1 4.206 4.206z",
    transform: "translate(1472.039 2794.701)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59695",
    d: "M83.546 55.2a4.206 4.206 0 1 1-4.206-4.206 4.207 4.207 0 0 1 4.206 4.206z",
    transform: "translate(1477.531 2798.24)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59696",
    d: "m109.248 66.893-22.569-6.048 6.048 22.568 4.928-4.928L108.3 89.126l6.664-6.663-10.645-10.642z",
    transform: "translate(1481.04 2801.235)",
    style: {
      stroke: "#4cbbb8",
      strokeLinejoin: "round",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFmsModeling);
export default __webpack_public_path__ + "static/media/ico_fms_modeling.110296d2898df6adc3dd7dbe9611c213.svg";
export { ForwardRef as ReactComponent };